import { createSlice } from "@reduxjs/toolkit";
import { postRequest } from "../../services/apiCaller/cl_index";
import { endpoints } from "../../api/ApiEndPoints";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";

const initialState = {
  messageCenterData: "",
  markAllAsReadRes: "",
  markAsDelete: "",
};
const token = getFromLocalStorage("gk");
export const messageCnterSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    setMessageCenterData: (state, action) => {
      state.messageCenterData = action.payload;
    },
    setMarkAllAsReadRes: (state, action) => {
      state.markAllAsReadRes = action.payload;
    },
    setMarkAsDelete: (state, action) => {
      state.markAsDelete = action.payload;
    },
  },
});

export const { setMessageCenterData, setMarkAllAsReadRes, setMarkAsDelete } =
  messageCnterSlice.actions;

export default messageCnterSlice.reducer;

export const fetchMessages = (mobNum) => (dispatch) => {
  let url = endpoints.messageNotification;
  const payload = {
    accessToken: token,
    itemsPerPage: 10,
    pageNumber: 1
  };
  postRequest(url, payload).then((res) => {
    if (res?.status === 200) {
      dispatch(setMessageCenterData(res.data));
    }
  });
};

export const markAllAsRead = (mobNum) => (dispatch) => {
  let url = endpoints.markAllAsRead;
  const payload = {
    accessToken: token,
    itemsPerPage: 10,
    pageNumber: 1
  };
  postRequest(url, payload).then((res) => {
    if (res?.status === 200) {
      dispatch(setMarkAllAsReadRes(res.data));
      dispatch(fetchMessages());
    }
  });
};

export const markAsDelete = (mobNum) => (dispatch) => {
  let url = endpoints.markAsDelete;
  const payload = {
    accessToken: token,
    itemsPerPage: 10,
    pageNumber: 1
  };
  postRequest(url, payload).then((res) => {
    if (res?.status === 200) {
      dispatch(setMarkAsDelete(res.data));
      dispatch(fetchMessages());
    }
  });
};
